<form no-validate (ngSubmit)="onSubmit(form)" [formGroup]="form">
    <div permissionShow="iqba.searchForm.sector">
        <ng-container *ngIf="canShow('segment')">
            <ng-container [ngTemplateOutlet]="this['segment']"
                          [ngTemplateOutletContext]="{ info: config['segment'] }"></ng-container>
        </ng-container>
    </div>

    <div class="col-to-row-s-tb ctn-top">
        <div *ngIf="canShow('quantity')" permissionShow="iqba.searchForm.quantity">
            <ng-container [ngTemplateOutlet]="this['quantity']"
                          [ngTemplateOutletContext]="{ info: config['quantity'] }"></ng-container>
        </div>
        <div class="flex-1"></div>
    </div>

    <div class="col-to-row-s-tb ctn-top sep-bottom">
        <div class="flex-1 sep-right keyword" *ngIf="canShow('keyword')">
            <ng-container [ngTemplateOutlet]="this['keyword']"
                            [ngTemplateOutletContext]="{ info: config['keyword'] }"></ng-container>
        </div>

        <div class="flex-1 sep-right" *ngIf="canShow('flexibility') && canDefineFlexibility()"
             permissionShow="iqba.searchForm.plusOrMinus">
            <ng-container [ngTemplateOutlet]="this['flexibility']"
                          [ngTemplateOutletContext]="{ info: config['flexibility'] }"></ng-container>
        </div>

        <div class="flex-1 sep-right cabin" *ngIf="canShow('cabin')">
            <ng-container [ngTemplateOutlet]="this['cabin']"
                            [ngTemplateOutletContext]="{ info: config['cabin'] }"></ng-container>
        </div>

        <div class="flex-1 maxVias" *ngIf="canShow('maxVias')">
            <ng-container [ngTemplateOutlet]="this['maxVias']"
                            [ngTemplateOutletContext]="{ info: config['maxVias'] }"></ng-container>
        </div>
    </div>

    <div class="col-to-row-s-tb ctn-top sep-bottom">
        <div class="flex-1 sep-right e2e-sources-select" *ngIf="canShow('host')" permissionShow="iqba.searchForm.host">
            <ng-container [ngTemplateOutlet]="this['host']"
                        [ngTemplateOutletContext]="{ info: config.host }"></ng-container>
        </div>

        <div *ngIf="canShow('host')" permissionShow="iqba.searchForm.host">
            <ng-container [ngTemplateOutlet]="this['lcc']"
                          [ngTemplateOutletContext]="{ info: config['lcc'] }"></ng-container>
        </div>

        <div class="flex-1 sep-right">
            <div > <!-- 1 = default value -->
                <ng-container
                    [ngTemplateOutlet]="this['locator']"
                    [ngTemplateOutletContext]="{ info: config.locator }"></ng-container>
            </div>
        </div>

        <!-- Empty space for now. Keep normal size when only one field -->
        <div class="flex-1 sep-right"></div>
        <div class="flex-1"></div>
    </div>

    <div *ngIf="canShow('price') || canShow('carrier')"
         [permissionShow]="'iqba.searchForm.additional.price' || 'iqba.searchForm.additional.carrier'"
         class="set-marge-bottom moreCrit">
        <btnForm styleType="actionLink" formType="button" (click)="showMoreCrit = !showMoreCrit">
            {{Yii.t('wui-shared-js', 'Critères supplémentaires')}}
            <fa-icon [icon]="!showMoreCrit ? iconDown : iconUp"></fa-icon>
        </btnForm>
    </div>

    <div *ngIf="canShow('price')" [hidden]="!showMoreCrit" permissionShow="iqba.searchForm.additional.price">
        <ng-container [ngTemplateOutlet]="this['price']"
                      [ngTemplateOutletContext]="{ info: config['price'] }"></ng-container>
    </div>
    <div *ngIf="canShow('carrier')" [hidden]="!showMoreCrit" permissionShow="iqba.searchForm.additional.carrier">
        <ng-container [ngTemplateOutlet]="this['carrier']"
                      [ngTemplateOutletContext]="{ info: config['carrier'] }"></ng-container>
    </div>

    <!-- </ng-container> -->

    <div class="submit-ctn">
        <btnForm class="e2e-search-btn" styleType="actionPrincipal" formType="submit" [disabled]="form.invalid">{{Yii.t('wui-shared-js',
            'Rechercher')}}
        </btnForm>
    </div>

    <ng-template #quantity let-info="info">
        <div class="ctn">
            <quantity-fieldset [group]="form.controls.quantity" class="fieldset" [config]="info"
                               [fieldsetData]="searchData ? searchData.quantity: null" [readOnlyTravellers]="readonlyParams || isFromWatabi"></quantity-fieldset>
        </div>
    </ng-template>

    <ng-template #segment let-info="info">
        <div class="ctn segment-ctn">
            <segment-air-fieldset class="fieldset"
                [group]="form.controls.segment"
                [config]="info"
                [fieldsetData]="searchData ? searchData.segment: null"></segment-air-fieldset>
        </div>
    </ng-template>

    <ng-template #carrier let-info="info">
        <div class="ctn segment-ctn">
            <carrier-fieldset class="fieldset"
                              [group]="form.controls.carrier" [config]="info"
                              [fieldsetData]="searchData ? searchData.carrier: null"></carrier-fieldset>
        </div>
    </ng-template>

    <ng-template #price let-info="info">
        <div class="col-to-row-s-tb ctn-top">
            <price-fieldset
                    class="flex-2"
                    [group]="form.controls.price" [config]="info" [options]="fareTypeList"
                    [fieldsetData]="searchData ? searchData.price: null"></price-fieldset>
            <multiselect class="flex-1"
                        [fieldConfig]="getFareTypeConfig()"
                        [options]="fareTypeList"></multiselect>
        </div>
    </ng-template>

    <ng-template #locator let-info="info">
        <combobox-field
            [fieldConfig]="locatorFieldSpec"
            [items]="locatorItems"></combobox-field>
    </ng-template>

    <ng-template #keyword>
        <multiselect class="h2-title"
                [fieldConfig]="getKeywordConfig()"
                [options]="keywordList"></multiselect>
    </ng-template>

    <ng-template #flexibility>
        <combobox-field
            [fieldConfig]="flexibilityFieldSpec"
            [items]="flexibilityItems"></combobox-field>
    </ng-template>

    <ng-template #maxVias>
        <combobox-field
            [fieldConfig]="maxViasFieldSpec"
            [items]="maxViasItems"></combobox-field>
    </ng-template>

    <ng-template #cabin>
        <combobox-field
            [fieldConfig]="cabinFieldSpec"
            [items]="cabinItems"></combobox-field>
    </ng-template>

    <ng-template #host let-info="info">
        <div class="ctn price-ctn">
            <multiselect class="h2-title"
                         (selectionChange)="handleHostChange($event)"
                         [fieldConfig]="getHostConfig()"
                         [options]="hostsList"></multiselect>
        </div>
    </ng-template>

    <ng-template #lcc let-info="info">
            <checkbox-field *ngIf="excludeLowCostEnabled" [fieldConfig]="excludeLowCostFieldSpec"></checkbox-field>
    </ng-template>

</form>
